import * as benchlingUtil from 'BenchlingUtil';
import EntityStore from 'stores/EntityStore';

function ifCreateFromHash(hash: string, callback: (currentHash: string) => void): void {
  const currentHash = window.location.hash;
  if (!currentHash.startsWith(hash)) {
    return;
  }

  // If the user isn't logged in, issue a redirect for this page.
  if (EntityStore.currentUser() == null) {
    benchlingUtil.redirectToSignin();
    return;
  }

  callback(currentHash);

  // Clear hash after it's been handled
  window.location.hash = '';
}

export default ifCreateFromHash;
